// AUTO-GENERATED from Firestore dump. Do not edit by hand.
// Source: scripts/build-static-config.mjs (config version 23)

import type { TvmFormDefinition } from "../types";

const form: TvmFormDefinition = {
	"formula": {
		"gateConsumptionC": "((mainEnginePower/2.6)*10)*0.25",
		"trawlCablePullC": "(mainEnginePower/2.6)*10",
		"gateAreaF": "(((mainEnginePower/2.6)*10)*0.25*2)/(gateLateralCoefficient*104*trawlSpeed)",
		"trawlCablePullF": "(mainEnginePower/2.1)*10",
		"gateConsumptionF": "((mainEnginePower/2.1)*10)*0.25",
		"gateAreaC": "(((mainEnginePower/2.1)*10)*0.25*2)/(gateLateralCoefficient*104*trawlSpeed)",
		"__cond": {
			"trawlSystem == 2 && mainEnginePower > 3500 && mainEnginePower <= 4000": {
				"max_weight": {
					"label": "Peso máximo",
					"type": "EXPRESSION",
					"value": "mainEnginePower*0.55"
				},
				"min_area": {
					"value": 6,
					"label": "Área mínima"
				},
				"max_area": {
					"value": 7.6,
					"label": "Área máxima"
				},
				"min_weight": {
					"label": "Peso mínimo",
					"type": "EXPRESSION",
					"value": "mainEnginePower*0.40"
				}
			},
			"trawlSystem == 2 && mainEnginePower > 2700 && mainEnginePower <= 3000": {
				"max_area": {
					"label": "Área máxima",
					"value": 6.6
				},
				"min_area": {
					"value": 6,
					"label": "Área mínima"
				},
				"min_weight": {
					"label": "Peso mínimo",
					"type": "EXPRESSION",
					"value": "mainEnginePower*0.40"
				},
				"max_weight": {
					"type": "EXPRESSION",
					"value": "mainEnginePower*0.55",
					"label": "Peso máximo"
				}
			},
			"(trawlSystem == 0 || trawlSystem == 1) && mainEnginePower > 4000 && mainEnginePower <= 4500": {
				"max_weight": {
					"value": "mainEnginePower",
					"type": "EXPRESSION",
					"label": "Peso máximo"
				},
				"max_area": {
					"value": 11,
					"label": "Área máxima"
				},
				"min_weight": {
					"type": "EXPRESSION",
					"value": "mainEnginePower*0.80",
					"label": "Peso mínimo"
				},
				"min_area": {
					"value": 9,
					"label": "Área mínima"
				}
			},
			"(trawlSystem == 0 || trawlSystem == 1) && mainEnginePower > 500 && mainEnginePower <= 700": {
				"min_area": {
					"label": "Área mínima",
					"value": 2.2
				},
				"min_weight": {
					"label": "Peso mínimo",
					"value": "mainEnginePower*0.70",
					"type": "EXPRESSION"
				},
				"max_area": {
					"value": 3.5,
					"label": "Área máxima"
				},
				"max_weight": {
					"type": "EXPRESSION",
					"value": "mainEnginePower",
					"label": "Peso máximo"
				}
			},
			"(trawlSystem == 0 || trawlSystem == 1) && mainEnginePower > 4500 && mainEnginePower <= 5500": {
				"max_weight": {
					"label": "Peso máximo",
					"type": "EXPRESSION",
					"value": "mainEnginePower"
				},
				"max_area": {
					"label": "Área máxima",
					"value": 12
				},
				"min_weight": {
					"type": "EXPRESSION",
					"value": "mainEnginePower*0.80",
					"label": "Peso mínimo"
				},
				"min_area": {
					"label": "Área mínima",
					"value": 9
				}
			},
			"trawlSystem == 2 && mainEnginePower >= 100 && mainEnginePower <= 300": {
				"max_weight": {
					"label": "Peso máximo",
					"value": "mainEnginePower*0.45",
					"type": "EXPRESSION"
				},
				"max_area": {
					"label": "Área máxima",
					"value": 0.84
				},
				"min_area": {
					"value": 0.76,
					"label": "Área mínima"
				},
				"min_weight": {
					"label": "Peso mínimo",
					"type": "EXPRESSION",
					"value": "mainEnginePower*0.35"
				}
			},
			"trawlSystem == 2 && mainEnginePower > 3000 && mainEnginePower <= 3500": {
				"max_area": {
					"value": 7,
					"label": "Área máxima"
				},
				"min_weight": {
					"label": "Peso mínimo",
					"type": "EXPRESSION",
					"value": "mainEnginePower*0.40"
				},
				"min_area": {
					"label": "Área mínima",
					"value": 6
				},
				"max_weight": {
					"value": "mainEnginePower*0.55",
					"type": "EXPRESSION",
					"label": "Peso máximo"
				}
			},
			"(trawlSystem == 0 || trawlSystem == 1) && mainEnginePower > 2100 && mainEnginePower <= 2700": {
				"max_area": {
					"value": 7.5,
					"label": "Área máxima"
				},
				"min_area": {
					"label": "Área mínima",
					"value": 6.5
				},
				"min_weight": {
					"type": "EXPRESSION",
					"value": "mainEnginePower*0.80",
					"label": "Peso mínimo"
				},
				"max_weight": {
					"value": "mainEnginePower",
					"type": "EXPRESSION",
					"label": "Peso máximo"
				}
			},
			"trawlSystem == 2 && mainEnginePower > 1700 && mainEnginePower <= 2400": {
				"max_area": {
					"label": "Área máxima",
					"value": 5.5
				},
				"min_area": {
					"value": 5,
					"label": "Área mínima"
				},
				"min_weight": {
					"label": "Peso mínimo",
					"value": "mainEnginePower*0.40",
					"type": "EXPRESSION"
				},
				"max_weight": {
					"type": "EXPRESSION",
					"value": "mainEnginePower*0.55",
					"label": "Peso máximo"
				}
			},
			"(trawlSystem == 0 || trawlSystem == 1) && mainEnginePower > 2700 && mainEnginePower <= 3000": {
				"max_area": {
					"label": "Área máxima",
					"value": 8.5
				},
				"min_weight": {
					"type": "EXPRESSION",
					"value": "mainEnginePower*0.80",
					"label": "Peso mínimo"
				},
				"min_area": {
					"value": 7,
					"label": "Área mínima"
				},
				"max_weight": {
					"value": "mainEnginePower",
					"type": "EXPRESSION",
					"label": "Peso máximo"
				}
			},
			"trawlSystem == 2 && mainEnginePower > 1200 && mainEnginePower <= 1700": {
				"max_weight": {
					"value": "mainEnginePower*0.50",
					"type": "EXPRESSION",
					"label": "Peso máximo"
				},
				"max_area": {
					"value": 4.4,
					"label": "Área máxima"
				},
				"min_area": {
					"value": 4,
					"label": "Área mínima"
				},
				"min_weight": {
					"label": "Peso mínimo",
					"type": "EXPRESSION",
					"value": "mainEnginePower*0.40"
				}
			},
			"trawlSystem == 2 && mainEnginePower > 900 && mainEnginePower <= 1200": {
				"max_weight": {
					"value": "mainEnginePower*0.50",
					"type": "EXPRESSION",
					"label": "Peso máximo"
				},
				"max_area": {
					"value": 3.3,
					"label": "Área máxima"
				},
				"min_weight": {
					"label": "Peso mínimo",
					"value": "mainEnginePower*0.35",
					"type": "EXPRESSION"
				},
				"min_area": {
					"label": "Área mínima",
					"value": 3
				}
			},
			"trawlSystem == 2 && mainEnginePower > 4500 && mainEnginePower <= 5500": {
				"max_area": {
					"value": 8.8,
					"label": "Área máxima"
				},
				"min_weight": {
					"label": "Peso mínimo",
					"value": "mainEnginePower*0.40",
					"type": "EXPRESSION"
				},
				"min_area": {
					"label": "Área mínima",
					"value": 6.5
				},
				"max_weight": {
					"label": "Peso máximo",
					"value": "mainEnginePower*0.60",
					"type": "EXPRESSION"
				}
			},
			"(trawlSystem == 0 || trawlSystem == 1) && mainEnginePower > 3000 && mainEnginePower <= 3500": {
				"max_weight": {
					"value": "mainEnginePower",
					"type": "EXPRESSION",
					"label": "Peso máximo"
				},
				"max_area": {
					"value": 9,
					"label": "Área máxima"
				},
				"min_weight": {
					"label": "Peso mínimo",
					"type": "EXPRESSION",
					"value": "mainEnginePower*0.80"
				},
				"min_area": {
					"label": "Área mínima",
					"value": 8
				}
			},
			"(trawlSystem == 0 || trawlSystem == 1) && mainEnginePower > 900 && mainEnginePower <= 1200": {
				"max_weight": {
					"type": "EXPRESSION",
					"value": "mainEnginePower",
					"label": "Peso máximo"
				},
				"max_area": {
					"label": "Área máxima",
					"value": 4.5
				},
				"min_weight": {
					"label": "Peso mínimo",
					"type": "EXPRESSION",
					"value": "mainEnginePower*0.70"
				},
				"min_area": {
					"value": 3,
					"label": "Área mínima"
				}
			},
			"(trawlSystem == 0 || trawlSystem == 1) && mainEnginePower > 5500 && mainEnginePower <= 7000": {
				"max_area": {
					"value": 13,
					"label": "Área máxima"
				},
				"min_area": {
					"label": "Área mínima",
					"value": 11
				},
				"min_weight": {
					"label": "Peso mínimo",
					"type": "EXPRESSION",
					"value": "mainEnginePower*0.80"
				},
				"max_weight": {
					"value": "mainEnginePower",
					"type": "EXPRESSION",
					"label": "Peso máximo"
				}
			},
			"(trawlSystem == 0 || trawlSystem == 1) && mainEnginePower >= 100 && mainEnginePower <= 300": {
				"max_area": {
					"label": "Área máxima",
					"value": 1.1
				},
				"min_area": {
					"value": 0.8,
					"label": "Área mínima"
				},
				"min_weight": {
					"label": "Peso mínimo",
					"value": "mainEnginePower*0.70",
					"type": "EXPRESSION"
				},
				"max_weight": {
					"type": "EXPRESSION",
					"value": "mainEnginePower",
					"label": "Peso máximo"
				}
			},
			"(trawlSystem == 0 || trawlSystem == 1) && mainEnginePower > 300 && mainEnginePower <= 500": {
				"max_weight": {
					"label": "Peso máximo",
					"value": "mainEnginePower",
					"type": "EXPRESSION"
				},
				"max_area": {
					"label": "Área máxima",
					"value": 2.2
				},
				"min_area": {
					"label": "Área mínima",
					"value": 1
				},
				"min_weight": {
					"type": "EXPRESSION",
					"value": "mainEnginePower*0.70",
					"label": "Peso mínimo"
				}
			},
			"trawlSystem == 2 && mainEnginePower > 500 && mainEnginePower <= 700": {
				"max_weight": {
					"label": "Peso máximo",
					"value": "mainEnginePower*0.50",
					"type": "EXPRESSION"
				},
				"max_area": {
					"value": 2.5,
					"label": "Área máxima"
				},
				"min_area": {
					"value": 2.2,
					"label": "Área mínima"
				},
				"min_weight": {
					"value": "mainEnginePower*0.35",
					"type": "EXPRESSION",
					"label": "Peso mínimo"
				}
			},
			"trawlSystem == 2 && mainEnginePower > 4000 && mainEnginePower <= 4500": {
				"max_area": {
					"label": "Área máxima",
					"value": 8
				},
				"min_weight": {
					"label": "Peso mínimo",
					"type": "EXPRESSION",
					"value": "mainEnginePower*0.40"
				},
				"min_area": {
					"label": "Área mínima",
					"value": 6.3
				},
				"max_weight": {
					"label": "Peso máximo",
					"value": "mainEnginePower*0.55",
					"type": "EXPRESSION"
				}
			},
			"(trawlSystem == 0 || trawlSystem == 1) && mainEnginePower > 1500 && mainEnginePower <= 2100": {
				"max_area": {
					"value": 7,
					"label": "Área máxima"
				},
				"min_area": {
					"label": "Área mínima",
					"value": 5
				},
				"min_weight": {
					"label": "Peso mínimo",
					"value": "mainEnginePower*0.75",
					"type": "EXPRESSION"
				},
				"max_weight": {
					"type": "EXPRESSION",
					"value": "mainEnginePower",
					"label": "Peso máximo"
				}
			},
			"trawlSystem == 2 && mainEnginePower > 5500 && mainEnginePower <= 7000": {
				"max_weight": {
					"value": "mainEnginePower*0.60",
					"type": "EXPRESSION",
					"label": "Peso máximo"
				},
				"max_area": {
					"value": 9.7,
					"label": "Área máxima"
				},
				"min_area": {
					"value": 7,
					"label": "Área mínima"
				},
				"min_weight": {
					"label": "Peso mínimo",
					"value": "mainEnginePower*0.40",
					"type": "EXPRESSION"
				}
			},
			"(trawlSystem == 0 || trawlSystem == 1) && mainEnginePower > 700 && mainEnginePower <= 900": {
				"max_area": {
					"label": "Área máxima",
					"value": 3.6
				},
				"min_weight": {
					"value": "mainEnginePower*0.70",
					"type": "EXPRESSION",
					"label": "Peso mínimo"
				},
				"min_area": {
					"label": "Área mínima",
					"value": 2.5
				},
				"max_weight": {
					"value": "mainEnginePower",
					"type": "EXPRESSION",
					"label": "Peso máximo"
				}
			},
			"trawlSystem == 2 && mainEnginePower > 700 && mainEnginePower <= 900": {
				"max_area": {
					"value": 2.86,
					"label": "Área máxima"
				},
				"min_weight": {
					"label": "Peso mínimo",
					"type": "type",
					"value": "mainEnginePower*0.35"
				},
				"min_area": {
					"label": "Área mínima",
					"value": 2.6
				},
				"max_weight": {
					"label": "Peso máximo",
					"value": "mainEnginePower*0.50",
					"type": "EXPRESSION"
				}
			},
			"(trawlSystem == 0 || trawlSystem == 1) && mainEnginePower > 3500 && mainEnginePower <= 4000": {
				"max_area": {
					"label": "Área máxima",
					"value": 10
				},
				"min_area": {
					"value": 8.4,
					"label": "Área mínima"
				},
				"min_weight": {
					"label": "Peso mínimo",
					"value": "mainEnginePower*0.80",
					"type": "EXPRESSION"
				},
				"max_weight": {
					"label": "Peso máximo",
					"type": "EXPRESSION",
					"value": "mainEnginePower"
				}
			},
			"trawlSystem == 2 && mainEnginePower > 300 && mainEnginePower <= 500": {
				"min_area": {
					"label": "Área mínima",
					"value": 1.32
				},
				"max_area": {
					"label": "Área máxima",
					"value": 1.45
				},
				"min_weight": {
					"label": "Peso mínimo",
					"type": "EXPRESSION",
					"value": "mainEnginePower*0.35"
				},
				"max_weight": {
					"type": "EXPRESSION",
					"value": "mainEnginePower*0.45",
					"label": "Peso máximo"
				}
			},
			"(trawlSystem == 0 || trawlSystem == 1) && mainEnginePower > 1200 && mainEnginePower <= 1500": {
				"max_weight": {
					"label": "Peso máximo",
					"value": "mainEnginePower",
					"type": "EXPRESSION"
				},
				"max_area": {
					"label": "Área máxima",
					"value": 5
				},
				"min_area": {
					"value": 4,
					"label": "Área mínima"
				},
				"min_weight": {
					"label": "Peso mínimo",
					"type": "EXPRESSION",
					"value": "mainEnginePower*0.75"
				}
			},
			"trawlSystem == 2 && mainEnginePower > 2400 && mainEnginePower <= 2700": {
				"min_area": {
					"value": 5.5,
					"label": "Área mínima"
				},
				"max_area": {
					"value": 6,
					"label": "Área máxima"
				},
				"min_weight": {
					"type": "EXPRESSION",
					"value": "mainEnginePower*0.40",
					"label": "Peso mínimo"
				},
				"max_weight": {
					"label": "Peso máximo",
					"value": "mainEnginePower*0.55",
					"type": "EXPRESSION"
				}
			}
		}
	},
	"flags": {
		"fresh": {
			"expression": "shipType == 0",
			"defValue": true
		},
		"simpleDouble": {
			"defValue": true,
			"expression": "trawlSystem == 0 || trawlSystem == 1"
		}
	},
	"fields": {
		"mainEnginePower": {
			"name": "mainEnginePower",
			"value": 0,
			"label": "$form_trawl_gates_main_power",
			"index": 0,
			"type": "INPUT",
			"inputType": "number"
		},
		"trawlSystem": {
			"value": "0",
			"name": "trawlSystem",
			"selectOptions": [
				{
					"key": 0,
					"label": "$form_trawl_gates_system_simple"
				},
				{
					"key": 1,
					"label": "$form_trawl_gates_system_twin"
				},
				{
					"key": 2,
					"label": "$form_trawl_gates_system_pelagic"
				}
			],
			"type": "SELECT",
			"index": 4,
			"label": "$form_trawl_gates_system",
			"inputType": "select"
		},
		"shipType": {
			"inputType": "select",
			"index": 3,
			"label": "$form_trawl_gates_ship",
			"type": "SELECT",
			"selectOptions": [
				{
					"key": "0",
					"label": "$form_trawl_gates_ship_fresh"
				},
				{
					"key": "1",
					"label": "$form_trawl_gates_freezer"
				}
			],
			"name": "shipType",
			"value": "0"
		},
		"gateLateralCoefficient": {
			"inputType": "number",
			"type": "INPUT",
			"label": "$form_trawl_gates_CL",
			"index": 2,
			"value": 0,
			"name": "gateLateralCoefficient"
		},
		"trawlSpeed": {
			"value": 0,
			"name": "trawlSpeed",
			"type": "INPUT",
			"index": 1,
			"label": "$form_trawl_gates_speed",
			"inputType": "number"
		}
	},
	"hints": {
		"htmlDef": "<div style=\"font-family: Helvetica; font-size: 22px;\">     <p>{{form_trawl_gates_hints_p1}}</p>     <p>{{form_trawl_gates_hints_p2}}</p>     <p>{{form_trawl_gates_hints_p3}}</p>     <p>{{form_trawl_gates_hints_p4}}</p>     <p>{{form_trawl_gates_hints_p5}}</p>     <p>{{form_trawl_gates_hints_p6}}</p>     <ul>        <li>{{form_trawl_gates_hints_p7}}</li>        <li>{{form_trawl_gates_hints_p8}}</li>        <li>{{form_trawl_gates_hints_p9}}</li>     </ul>     <p>{{form_trawl_gates_hints_p10}}</p>     <ul>        <li>{{form_trawl_gates_hints_p11}}</li>        <li>{{form_trawl_gates_hints_p12}}</li>        <li>{{form_trawl_gates_hints_p13}}</li>        <li>{{form_trawl_gates_hints_p14}}</li>        <li>{{form_trawl_gates_hints_p15}}</li>     </ul>     {{form_trawl_gates_hints_img_1}}     {{form_trawl_gates_hints_img_2}}     {{form_trawl_gates_hints_img_3}}     {{form_trawl_gates_hints_img_4}}     {{form_trawl_gates_hints_img_5}}     {{form_trawl_gates_hints_img_6}}    </div>",
		"title": "Puertas de arrastre"
	}
};

export const trawlGate = form;
